import { uninterested, contactList, contactCount, unlockContacts, testPoint } from '../api/newClueApi'
import { X_BLOCK, X_PRODUCT, X_HIDE } from '@/utils/iframeUtils'
const getPwdPhoneNumFunc = (e, i) => {
  if (i > 2 && i < 7) { return '*' }
  return e
}
export default {
  inject: {
    unlockSourceType: {
      default: undefined
    }
  },
  data() {
    return {
      waiting: false,
      showIndex: 0,
      numberData: [
        { title: '手机', type: 1, list: [], checkedAll: false, indeterminate: false, pageNum: 1, pageSize: 10, total: 0 },
        { title: '固话', type: 2, list: [], checkedAll: false, indeterminate: false, pageNum: 1, pageSize: 10, total: 0 },
        { title: '邮箱', type: 3, list: [], checkedAll: false, indeterminate: false, pageNum: 1, pageSize: 10, total: 0 },
        { title: '全部', type: null, list: [], checkedAll: false, indeterminate: false, pageNum: 1, pageSize: 10, total: 0 }
      ],
      drawer: false,
    }
  },
  methods: {
    // 联系方式 获取
    async getContactCount() {
      this.waiting = true
      try {
        const { data } = await contactCount({ hids: [this.companyStatus.hid] })
        this.$set(this.companyStatus, 'contactCount', data[0])
        const { countMap } = data[0]
        this.numberData[3].total = data[0].contactCount || 0
        // 1:手机，2:固话，3:邮箱，4:微信，5:QQ，6:传真
        this.numberData[0].total = (countMap && countMap[1]) || 0
        this.numberData[1].total = (countMap && countMap[2]) || 0
        this.numberData[2].total = (countMap && countMap[3]) || 0
        this.waiting = false

        !this.numberData[0].total && this.firstLoadUnlock?.()

      } catch (e) { console.log(e), this.waiting = false }
      // 已解锁，不走埋点接口
      if (this.companyStatus.unlock && !window[X_BLOCK]) {
        this.getContactList(this.showIndex)
      }
    },
    // 解锁  每次触发接口axios里面会有监听，用来改变次数
    async getContactList(idx) {
      this.waiting = true
      if (idx !== undefined) this.showIndex = idx
      const res = await contactList({
        companyName: this.companyName, hid: this.companyStatus.hid,
        similarValue: this.companyStatus.similarValue, similarity: this.companyStatus.similarity,
        source: this.unlockSourceType,
        type: this.numberData[this.showIndex].type,
        pageNum: this.numberData[this.showIndex].pageNum,
        pageSize: this.numberData[this.showIndex].pageSize,
      })

      if (res.code === 200 && res.data.total) {
        const list = res.data.list.map(e => {
          const count = e.sources && e.sources.length
          let contactInfo = e.content
          // todo 领取的电话做特殊处理 下期做erp 和正式的兼容
          if ((process.env.NODE_ENV == 'erp-prod' || process.env.NODE_ENV == 'erp') && contactInfo && e.isTurnClue) {
            const arr = contactInfo.split('')
            contactInfo = arr.map((e, i) => {
              if (i > 2 && i < 7) {
                return '*'
              }
              return e
            }).join('')
          }
          return { ...e, contactInfo, count: count, contactInfoReal: contactInfo, active: false }
        })

        this.numberData[this.showIndex].pageNum++
        this.numberData[this.showIndex].list = [...this.numberData[this.showIndex].list, ...list]


        this.numberData[3].list.forEach(v => {
          v.sources.forEach(vv => {
            if (vv.source == "互联网公示") {
              v.tjIcon = true
            }
          })
        })
      }
      this.waiting = false
    }
  }
}